import React from 'react'
import { useSelector } from 'react-redux'
import { IconCheck } from '@tabler/icons-react'
import { SearchableDropdown } from '@/components/dropdowns/SearchableDropdown'
import { useAudioPlayer } from '../AudioPlayerContext'

export const PLAYBACK_RATE_OPTIONS = [
  { key: 0.5, label: '0.5x', value: 0.5 },
  { key: 0.75, label: '0.75x', value: 0.75 },
  { key: 1, label: '1x', value: 1 },
  { key: 1.25, label: '1.25x', value: 1.25 },
  { key: 1.5, label: '1.5x', value: 1.5 },
  { key: 1.75, label: '1.75x', value: 1.75 },
  { key: 2, label: '2x', value: 2 },
]

export const PlaybackRateDropdown = ({
  isDisabled,
  handlePlaybackRateChange,
  playbackRate,
  skipSilence,
  handleSkipSilenceChange,
  isTranscriptAvailable,
}) => {
  const { monoAudio, handleMonoAudioChange, corsSupported } = useAudioPlayer()
  const { organizationid: organizationId } = useSelector((state) => state.currentUser)
  const isBaltoAdmin = organizationId === 1
  const actions = [
    ...(isTranscriptAvailable
      ? [
          {
            key: 'skip-silence',
            fn: () => handleSkipSilenceChange(!skipSilence),
            label: (
              <div className="flex-align-center small-gap">
                Skip Silences
                {skipSilence && <IconCheck className="status-brand icon-svg" />}
              </div>
            ),
          },
        ]
      : []),
    ...(isBaltoAdmin && corsSupported
      ? [
          {
            key: 'mono-audio',
            fn: handleMonoAudioChange,
            label: (
              <div className="flex-align-center small-gap">
                Mono Audio
                {monoAudio && <IconCheck className="status-brand icon-svg" />}
              </div>
            ),
          },
        ]
      : []),
  ]

  return (
    <SearchableDropdown
      selectedOptionFirst={false}
      hideSearch
      options={PLAYBACK_RATE_OPTIONS}
      selected={playbackRate}
      handleSelect={(value) => {
        handlePlaybackRateChange(value)
      }}
      actions={actions}
      buttonProps={{ small: true }}
      isDisabled={isDisabled}
      tooltip="Change Playback Rate"
      dataTestId="playback-speed-dropdown"
    />
  )
}
